import styled from "styled-components";

import { ACITVE_CONTENT_PADDING_BOTTOM } from "CrossFeatureComponents/MemberToolbar/styleConstants";

import ActiveContentWrapper from "../ActiveContentWrapper";

import MiniProfile from "./MiniProfile";

const UserMenu = () => {
  return (
    <ActiveContentWrapper>
      <Wrapper data-cy="MemberToolbar_UserMenuContainer">
        <MiniProfile />
      </Wrapper>
    </ActiveContentWrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: ${ACITVE_CONTENT_PADDING_BOTTOM}px;
`;

export { UserMenu };
